export const UserGender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
}

export type UserGender = (typeof UserGender)[keyof typeof UserGender]

export const toPhiGender = (gender?: UserGender): string | undefined => {
  if (gender == null) return undefined

  if (gender === UserGender.FEMALE) return 'Female'
  if (gender === UserGender.MALE) return 'Male'
}
